{
  "title": "ไม่สามารถเช็กอินให้เสร็จสมบูรณ์ได้",
  "message": "ไม่สามารถตรวจสอบบัตรประจำตัวของคุณได้"
}
